import { NavLink, Outlet } from 'react-router-dom'
import { Home, MapPin, Settings } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function Layout() {
  const { t } = useTranslation()
  return (
    <div className="layout">
      <main className="layout__content">
        <Outlet />
      </main>
      <nav className="layout__nav">
        <NavLink to="/" end className="layout__tab">
          <Home size={22} />
          <span>{t('nav.home')}</span>
        </NavLink>
        <NavLink to="/address" className="layout__tab">
          <MapPin size={22} />
          <span>{t('nav.address')}</span>
        </NavLink>
        <NavLink to="/settings" className="layout__tab">
          <Settings size={22} />
          <span>{t('nav.settings')}</span>
        </NavLink>
      </nav>
    </div>
  )
}
